import { forwardRef } from 'react';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { PersonalIdentifierType } from '@/shared/lib/sj-orm';
import { BaseProps } from '@/shared/types';

import { PidType } from './PidType';

type PidTypeListToSelectProps = BaseProps<{
  onSelect: (category: PersonalIdentifierType) => void;
}>;

const pidTypesList = [
  PersonalIdentifierType.CITIZENSHIP_CERTIFICATE,
  PersonalIdentifierType.PASSPORT,
  PersonalIdentifierType.NATIONAL_ID,
  PersonalIdentifierType.BIRTH_CERTIFICATE,
  PersonalIdentifierType.RESIDENCE_PERMIT,
  PersonalIdentifierType.TAX_ID,
  PersonalIdentifierType.DRIVER_LICENSE,
  PersonalIdentifierType.INTERNATIONAL_DRIVER_LICENSE,
  PersonalIdentifierType.EDUCATION,
  PersonalIdentifierType.MEDICAL_ID,
  PersonalIdentifierType.SOCIAL_SECURITY,
  PersonalIdentifierType.MILITARY_ID,
  PersonalIdentifierType.FREE_BLOCK,
  PersonalIdentifierType.SUBSTANCE,
];

export const PidTypeListToSelect = forwardRef<HTMLDivElement, PidTypeListToSelectProps>(
  ({ onSelect, ...props }, ref) => {
    return (
      <Container {...props} className="uikitScrollbarNone" ref={ref}>
        <Group>
          {pidTypesList.map((type, index) => (
            <Item onClick={() => onSelect(type)} key={index}>
              <PidType type={type} />
            </Item>
          ))}
        </Group>
      </Container>
    );
  },
);

PidTypeListToSelect.displayName = 'PidTypeListToSelect';

const Container = styled.div`
  width: 280px;
  max-height: 686px;
  padding: 4px;
  border-radius: 16px;
  border: 1px solid ${COLORS.systemDark100};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight300};
`;

const Group = styled.div`
  padding: 4px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: ${COLORS.systemLight100};
`;

const Item = styled.div`
  height: 44px;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  gap: 8px;
  cursor: pointer;

  &:hover {
    background: ${COLORS.systemLight200};
  }
`;
